<template>
    <el-menu mode="horizontal" theme="light" @select="goTo" ref="topmenu" :default-active="$route.name">
        <el-submenu index="base-set">
            <template slot="title">
                账户信息
            </template>
            <el-menu-item index="UserInfo">基本信息</el-menu-item>
            <el-menu-item index="Password">登录密码</el-menu-item>
            <el-menu-item index="Weixin">微信绑定</el-menu-item>
        </el-submenu>
        <el-submenu index="finance-set" v-if="$store.state.perms.perms">
            <template slot="title">
                财务信息
            </template>
            <el-menu-item index="MoneyLogList">流水记录</el-menu-item>
            <el-menu-item index="DepositList">提现记录
            </el-menu-item>
            <el-menu-item index="DepositAdd">申请提现
            </el-menu-item>
        </el-submenu>
        <el-submenu index="warehouseManage" v-if="$store.state.perms.perms">
            <template slot="title">
                仓库管理
            </template>
            <el-menu-item index="WarehouseList">
                仓库列表
            </el-menu-item>
            <el-menu-item index="WarehouseUserList">
                员工管理
            </el-menu-item>
        </el-submenu>
        <el-submenu index="storageManage">
            <template slot="title">
                仓储管理
            </template>
            <el-menu-item index="ShelvesLocationList">
                库位管理
            </el-menu-item>
            <el-menu-item index="StorageProductList">
                商品管理
            </el-menu-item>
        </el-submenu>
        <el-menu-item index="MerchantList" v-if="$store.state.perms.perms">
            会员管理
        </el-menu-item>
        <el-menu-item index="WarehouseQrcode">
            客户网址
        </el-menu-item>
        <div class="user-dropdown-menu-con" style="float: right;margin-top: 5px;margin-right:15px">
            <el-row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
                <el-dropdown transfer trigger="click" @command="itemNetClick">
                    <a href="javascript:void(0)">
                        <span class="main-user-name">
                            {{ netName }}</span>
                        <i class="arrow-down-b"></i>
                    </a>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="KhNet">香港线路</el-dropdown-item>
                        <el-dropdown-item command="CnNet" divided>国内线路</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown style="margin-left:10px" transfer trigger="click" @command="itemClick">
                    <a href="javascript:void(0)">
                        <span class="main-user-name">
                            <template v-if="userInfo.main==1">
                                主管理员:
                            </template> <template v-else>{{merchId}}：</template>{{ userName }}</span>
                        <i class="arrow-down-b"></i>
                    </a>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="ownSpace">修改密码</el-dropdown-item>
                        <el-dropdown-item command="loginout" divided>退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-avatar :src="avatorPath" style="background: #619fe7;margin-left: 10px;"></el-avatar>
            </el-row>
        </div>
    </el-menu>
</template>
<script>
export default {
    name: 'CpMenu',
    data() {
        return {
            avatorPath: '',
            interval: null,
            netName: localStorage.netName
        };
    },
    computed: {

        userName() {

            return localStorage.userName;
        },
        merchId() {

            return localStorage.warehouseName;
        },
        userInfo() {

            return this.$store.state.user.userInfo;
        }
    },
    methods: {
        goTo: function(active) {

            var cpmenu = this.$refs.topmenu;


            this.$router.push({ name: active }, () => {}, (e) => {

            });
            this.$emit('on-change', active);
        },
        itemClick: function(name) {
            if ("ownSpace" == name) {
                this.$router.push({ name: "Password" });
            } else this.loginout();
        },
        itemNetClick: function(name) {

            if (name == 'KhNet') {
                localStorage.setItem("netName", "香港线路");
            } else {
                localStorage.setItem("netName", "国内线路");
            }
            this.netName = localStorage.netName;
            this.loginout();
        },
        loginout: function() {

            var me = this;
            me.$store
                .dispatch("loginOut")
                .then(res => {

                    if (res.status == 0) {
                        me.$router.push("/login");
                    } else {
                        me.errorMessage(res.info);
                    }
                }).catch(error => {


                    me.errorMessage("退出异常");

                });
        }
    }
}
</script>
<style>
</style>